import Link from "next/link";
import styles from "./index.module.css";

export const NotFound = () => {
  return (
    <main className={styles.errorPage} data-layout="page">
      <h1 className={styles.title}>404 - Siden ble ikke funnet</h1>
      <p className={styles.text}>
        Vi fant ikke siden du leter etter. Kanskje du kan finne det du leter
        etter i menyen?
      </p>

      <div className={styles.buttons}>
        <Link shallow={false} prefetch={false} href="/" type="button">
          Gå til forsiden
        </Link>
      </div>
    </main>
  );
};
